var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TransactionList',_vm._b({},'TransactionList',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }